import { VariantType, enqueueSnackbar } from "notistack"

export const notification = (type, e) => {
  let msg = e
  if (type === "error") {
    msg = msg
  }
  return enqueueSnackbar(msg, {
    variant: type,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  })
}

export const getName = str => {
  var str = str
  var matches = str?.match(/\b(\w)/g) // ['J','S','O','N']
  return matches?.join("")
}

export function downloadFile(data, name, fileType = "text/CSV") {
  const blob = new Blob([data], { type: fileType })
  const url = window.URL.createObjectURL(blob)

  const a = document.createElement("a")
  a.setAttribute("href", url)
  a.setAttribute("download", name)
  a.click()
}